import React, {useEffect, useState} from 'react';
import {Link} from 'gatsby';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/solid';


export default function Layout({children, className}) {

  const [showMenu, setShowMenu] = useState(false);

	return <div className="min-h-screen">
		<div className={`${className} top-0 left-0 w-full`}>
        <div className="container px-5 sm:px-0 mx-auto flex justify-between items-center py-5">
          <Link to={"/"}><img src="https://res.cloudinary.com/wigmarket/image/upload/v1672265975/dropship-beauty-logo_200x_2x_h9r4bf_oeynnl.png" className="w-32"/></Link>
          <div className={`${showMenu?'flex':'hidden'} z-40 md:flex bg-white/90 items-center justify-center h-screen flex-col md:flex-row top-0 left-0 md:h-auto md:bg-transparent md:justify-between md:w-2/3 lg:w-1/2 fixed md:relative w-full`}>
            <button  onClick={() => setShowMenu(false)} className="absolute right-5 top-5 z-50 md:hidden"><XMarkIcon className="w-10 h-10 text-black"/></button>
            <Link onClick={() => setShowMenu(false)} className="font-bold text-2xl md:text-sm font-basic uppercase text-black/80 border-transparent border-b-2 hover:border-black my-2 block leading-20" to="/#features">Features</Link>
            <Link onClick={() => setShowMenu(false)} className="font-bold text-2xl md:text-sm  font-basic uppercase text-black/80 border-transparent border-b-2 hover:border-black my-2 block leading-20" to="/collections/most-popular">Products</Link>
            <a href="https://www.shopify.com/?ref=dropship-hair-app" className="font-bold text-2xl md:text-sm font-basic  uppercase text-black/80 border-transparent border-b-2 hover:border-black my-2 block leading-20">Shopify</a>
            <a href="https://www.dropshipbeauty.com/collections/hair-website" className="font-bold text-2xl md:text-sm font-basic  uppercase text-black/80 border-transparent border-b-2 hover:border-black my-2 block leading-20">Websites for Sale</a>
            <Link onClick={() => setShowMenu(false)} className="font-bold text-2xl md:text-sm  font-basic uppercase text-black/80 border-transparent border-b-2 hover:border-black my-2 block leading-20" to="/#get-started">Get Started</Link>
          </div>
          <button className="md:hidden" onClick={() => setShowMenu(true)}><Bars3Icon className="w-10 h-10 text-black block"/></button>
        </div>
      </div>
      {children}
      <footer className="bg-slate-100 py-20">
      <div className="container mx-auto">
        <div className="sm:grid sm:grid-cols-4 pb-8 gap-4 px-4 md:px-0 space-y-4 sm:space-y-0">
          <div> 
            <h3 className="font-bold font-basic uppercase">PAGES</h3>
            <Link to={"/"} className="block font-basic text-gray-600  hover:text-indigo-600">Home</Link>
            <Link to={"/collections/most-popular"} className="block font-basic text-gray-600  hover:text-indigo-600">Products</Link>
            <Link to={"/quick-start"} className="block font-basic text-gray-600  hover:text-indigo-600">Expert Setup</Link>
            <a href="https://apps.shopify.com/dropship-beauty?ref=dropship-hair-app" className="block font-basic text-gray-600  hover:text-indigo-600">Shopify App</a>
            <a href="https://www.dropshipbeauty.com/collections/hair-website" className="block font-basic text-gray-600  hover:text-indigo-600">Websites for Sale</a>


          </div>
          <div>
            <h3 className="font-bold font-basic uppercase">SOCIAL</h3>
            <a target="_blank" href={"https://www.facebook.com/dropshipbeautyapp"} className="block font-basic text-gray-600  hover:text-indigo-600">Facebook</a>
            <a target="_blank" href={"https://www.instagram.com/privatelabel/?hl=en"} className="block font-basic text-gray-600  hover:text-indigo-600">Instagram</a>
            <a target="_blank" href={"https://www.youtube.com/@HairBusinessBlueprint"} className="block font-basic text-gray-600  hover:text-indigo-600">YouTube</a>
          </div>
          <div>
            <h3 className="font-bold font-basic uppercase">CONTACT</h3>
            <p className="block font-basic text-gray-600 ">1260 Memorial Dr SE, Atlanta, GA 30316</p>
            <a href={"mailto:support@dropshipbeauty.app"} className="block font-basic text-gray-600  hover:text-indigo-600">E: support@dropshipbeauty.app</a>
          </div>
          <div>
            <h3 className="font-bold font-basic uppercase">The Fine Print</h3>
            <a href={"/policy/terms"} className="block font-basic text-gray-600  hover:text-indigo-600">Terms of service</a>
            <a href={"/policy/privacy"} className="block font-basic text-gray-600  hover:text-indigo-600">Privacy policy</a>
            <a href={"/policy/returns"} className="block font-basic text-gray-600 hover:text-indigo-600 ">Return policy</a>
          </div>
        </div>
        <div className="sm:flex text-center justify-between items-center  border-t pt-5">
          <div className="sm:w-64 mb-3 sm:mb-0">
            <Link to={"/"}><img src="https://res.cloudinary.com/wigmarket/image/upload/v1672265975/dropship-beauty-logo_200x_2x_h9r4bf_oeynnl.png" className="w-32 mx-auto"/></Link>
          </div>
          <div className="text-center text-sm text-gray-800">
            { new Date().getFullYear()} &copy; Dropship Beauty. All rights reserved.
          </div>
          <div className="w-64 hidden sm:block">
            <a href={"https://www.shopify.com/?ref=dropship-hair-app"}><img src="https://res.cloudinary.com/wigmarket/image/upload/c_scale,q_auto,w_480/v1541709457/shopify-partner_bcmqf7.png" className="w-64"/></a>
          </div>
        </div>
      </div>
    </footer>
	</div>
}